import React from "react";
import RetailerWidgetSettingsFormik from "./RetailerWidgetSettingsFormik";
import RetailerWidgetSettingsFormView from "./RetailerWidgetSettingsFormView";

const RetailerWidgetSettings = ({ widgetToken, widgetSettings }) => {
    const settings = {
        buttonText: widgetSettings.buttonText || "",
        buttonColor: widgetSettings.buttonColor || "#B0C4B1",
        buttonTextColor: widgetSettings.buttonTextColor || "#000000",
        themeColor: widgetSettings.themeColor || "#D8B4A0",
        themeTextColor: widgetSettings.themeTextColor || "#223843",
        position: widgetSettings.position || "",
        // contentStatementText: widgetSettings.contentStatementText || "",
    };

    

    return (
        <RetailerWidgetSettingsFormik widgetSettings={settings}>
            {(props) => (
                    <RetailerWidgetSettingsFormView
                        widgetToken={widgetToken}
                        {...props}
                    />
            )}
        </RetailerWidgetSettingsFormik>
    );
};

export default RetailerWidgetSettings;
